import React, { useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import gs1_logo from "../../assets/img/gs1.png";
import GLOBALS from "../../utils/Globals";
import Image from "react-bootstrap/Image";

const ButtonRendererSearch = (props) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [company, setCompany] = React.useState(null);
  const [type, setType] = React.useState(null);
  const [status, setStatus] = React.useState(null);

  const [r_desc, setR_desc] = React.useState(null);
  const [r_date, setR_date] = React.useState(null);
  const [r_id, setR_id] = React.useState(null);
  const [recall, setRecall] = React.useState(null);

  const [thegtin, setTheGtin] = React.useState(null);
  const [gln, setGln] = React.useState(null);

  const [dcreated, setDcreated] = React.useState(null);
  const [dupdated, setDupdated] = React.useState(null);

  const baseURLGetGTINS =
    process.env.REACT_APP_ENV == "PROD"
      ? GLOBALS.PROD.baseURLGetGTINS
      : GLOBALS.DEV.baseURLGetGTINS;

  //var gtin = props.data.GTIN;

  //console.log(props.data)

  React.useEffect(() => {
    if (props.data.json === null) {
      console.log("null");
      
    } else {
      setCompany(props.data.gs1Licence.licenseeName);
      setType(props.data.gs1Licence.licenceType);
      setStatus(props.data.gtinRecordStatus);
      setTheGtin(props.data.gtin);
      setGln(props.data.gs1Licence.licenseeGLN);
      setDupdated(props.data.gs1Licence.dateUpdated);
      setDcreated(props.data.gs1Licence.dateCreated);
      setR_desc(props.data.Description);
      setR_date(props.data.RecallDate);
      setR_id(props.data.RecallID);
      setRecall(props.data.recall);
    }
    
  }, []);

  return (
    <>
      <Button variant="outline-primary" onClick={handleShow}>
        DETAILS
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>GTIN Details for {props.data.GTIN}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image src={gs1_logo} width="120px" height="120px" alt="GS1" />
          <br></br>
          <hr></hr>
          <br></br>
          Company Name : {company}
          <br></br>
          Type : {type}
          <br></br>
          Status : {status}
          <br></br>
          GTIN : {thegtin}
          <br></br>
          GLN : {gln}
          <br></br>
          Date Created : {dcreated}
          <br></br>
          Date Updated : {dupdated}
          <br></br>
          <br></br>
          {recall ? (
            <div>
              <h3>Recall Information</h3>
              <hr></hr>
              <br></br>
              Recall ID : {r_id}
              <br></br>
              Recall Date : {r_date}
              <br></br>
              Recall Description : {r_desc}
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ButtonRendererSearch;
